var map = {
	"./comodo-secure.png": 921,
	"./flag-france.png": 922,
	"./flag-germany.png": 923,
	"./flag-italy.png": 924,
	"./flag-netherlands.png": 925,
	"./flag-portugal.png": 926,
	"./flag-spain.png": 927,
	"./flag-usa.png": 928,
	"./global-cart-seal.png": 929,
	"./icon-wanelo copy.png": 930,
	"./icon-wanelo.png": 605,
	"./icon-whatsapp copy.png": 931,
	"./icon-whatsapp.png": 606,
	"./lock.png": 932,
	"./pagamento-cinza.png": 933,
	"./pagamento-verde.png": 934,
	"./pagamento-vermelho.png": 935,
	"./payment-methods-br.png": 936,
	"./payment-methods-global.png": 937,
	"./payment-methods.png": 938,
	"./pedido-cinza.png": 939,
	"./pedido-verde.png": 940,
	"./pedido-vermelho.png": 941,
	"./selo-ebit-ouro.png": 942,
	"./selo-eureciclo.png": 943,
	"./selo-internet-segura.png": 944,
	"./selo-ra1000.png": 945,
	"./selo_100-seguro-retina.png": 246,
	"./selo_100-seguro.png": 946,
	"./selo_site_seguro_certisign.png": 947,
	"./selo_site_seguro_mcafee.png": 247,
	"./selo_site_seguro_norton.png": 248,
	"./selo_site_seguro_norton_small.png": 948,
	"./separacao-cinza.png": 949,
	"./separacao-verde.png": 950,
	"./separacao-vermelho.png": 951,
	"./shipping-methods-global.png": 952,
	"./transporte-cinza.png": 953,
	"./transporte-verde.png": 954,
	"./transporte-vermelho.png": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 920;